/* eslint-disable react/no-danger */
/* eslint-disable max-len */
import React from 'react';

export default props => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="svg8"
      version="1.1"
      viewBox="0 0 14 14"
      height="14"
      width="14"
      {...props}
    >
      <g id="layer1">
        <path
          d="M 13.009766 0.28320312 L 7.3535156 5.9394531 L 8.0605469 6.6464844 L 13.716797 0.99023438 L 13.009766 0.28320312 z M 5.9394531 7.3535156 L 0.28320312 13.009766 L 0.99023438 13.716797 L 6.6464844 8.0605469 L 5.9394531 7.3535156 z "
          style={{ fill: '#000000', 'stroke-width': 0 }}
          id="rect855"
        />
        <path
          id="path872"
          style={{ fill: '#000000', 'stroke-width': 0 }}
          d="M 0.4714046,10.700168 3.2998318,13.528595 0,14 Z"
        />
        <path
          d="M 13.528594,3.2998313 10.700168,0.4714047 14,0 Z"
          style={{ fill: '#000000', 'stroke-width': 0 }}
          id="path872-2"
        />
      </g>
    </svg>
  );
};
